import Choices from "choices.js";
import Swiper from "swiper";

export default class Global {

    constructor() {
        this.initChoices();
        this.initProjects();
        this.showVideo();
    }

    showVideo() {
        if(document.getElementById('video-container') === null) {
            return;
        }
        const thumbnail = document.querySelector('.thumbnail');
        const videoContainer = document.getElementById('video-container');

        thumbnail.addEventListener('click', function() {
            thumbnail.style.display = 'none';
            videoContainer.style.display = 'block';
        });
    }

    initChoices() {
        const elements = document.querySelectorAll('.js-choice');
        let choices;

        elements.forEach(element => {
            choices = new Choices(element);
        });
    }

    initProjects() {
        if (document.getElementById('projects') !== null) {
            const container = document.querySelector('#projects .swiper-container');

            const swiper = new Swiper(container, {
                slidesPerView: 1,
                spaceBetween: 15,
                scrollbar: {
                    el: '.swiper-scrollbar',
                    draggable: true,
                },
                breakpoints: {
                    768: {
                        slidesPerView: 1.5,
                    },
                    992: {
                        slidesPerView: 2,
                        spaceBetween: 30,
                    }
                },
                autoplay: {
                    delay: 1,
                    disableOnInteraction: true
                },
                speed: 7000,
                freeModeMomentum: false
            });

            container.addEventListener('mouseenter', function (e) {
                swiper.autoplay.stop();
            });

            container.addEventListener('mouseleave', function (e) {
                swiper.autoplay.start();
            });
        }
    }

}
